export const INPUT_WIZARD_FLOWS = {
  ILLUMINATE: "ILLUMINATE",
  NON_ILLUMINATE: "NON_ILLUMINATE"
};
export const INPUT_WIZARD_STEPS = {
  INSTALL_ILLUMINATE: "INSTALL_ILLUMINATE",
  SELECT_ILLUMINATE: "SELECT_ILLUMINATE",
  SETUP_ROUTING: "SETUP_ROUTING",
  INPUT_DIAGNOSIS: "INPUT_DIAGNOSIS",
  START_INPUT: "START_INPUT"
};
